import { t } from '@lingui/core/macro'
import { createFileRoute, Outlet } from '@tanstack/react-router'

export const Route = createFileRoute('/_app/_dashboards')({
  component: RouteComponent,
  loader: () => ({
    breadcrumb: {
      label: t`Dashboards`,
    },
  }),
})

function RouteComponent() {
  return <Outlet />
}
